/* mega menu content hack below (on load)
also: see themes.css for mega menu styles and site-nav.liquid */

jQuery(window).bind("pageshow", function(event) { //fix safari bug backward/forwards cache  needed for page transitions
    if (event.originalEvent.persisted) {
        window.location.reload() 
    }
})


gsap.registerPlugin(ScrollTrigger);

/*
gsap.from('.site-header__mobile-nav', {
    scrollTrigger: {
      start: 'top top',
      end: '+=1000%',
      trigger: '.site-header__mobile-nav',
      toggleClass: 'small', 
      scrub: true
    }
  });
*/

ScrollTrigger.create({
  start: 'top -30',
  end: 99999,
  toggleClass: {className: 'small', targets: '.site-header__mobile-nav'}
});



 if ( $('.parallaxHero').length ) {

	/* parallax hero */

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: ".parallaxHero",
			start: "top top",
			end: "bottom top",
			scrub: true
		}
	});

	gsap.utils.toArray(".parallax").forEach(layer => {
		const depth = layer.dataset.depth;
		const movement = -(layer.offsetHeight * depth)
		tl.to(layer, {y: movement, ease: "none"}, 0)
	});

	/* end parallax hero */
 }


 if ( $('.fadeIn').length ) {

	gsap.set('.fadeIn', {  opacity: 0   })

	var fadeIns = gsap.utils.toArray('.fadeIn');

	fadeIns.forEach((section) => {

	  gsap.to(section, { alpha: 1,
		scrollTrigger: {
			trigger: section,
			start: 'top 95%',
			scrub: true,
			end: 'top 65%',
		  toggleActions: "play none none reverse"
			//markers: true
		  },
		  ease: "power2.inOut"
		});

	})

 }


 if ( $('.fadeInUp').length ) {

	gsap.set('.fadeInUp', {  opacity: 0, y: 20   })

	var fadeInUps = gsap.utils.toArray('.fadeInUp');

	fadeInUps.forEach((section) => {

	  gsap.to(section, { alpha: 1, y: 0,
		scrollTrigger: {
			trigger: section,
			start: 'top 95%',
			scrub: false,
			end: 'top 75%',
		  toggleActions: "play none none reverse"
			//markers: true
		  },
		  ease: "power2.inOut"
		});

	})
 }


 if ( $('.fadeInContours').length ) {

	gsap.set('.fadeInContours', {  opacity: 0, y: 200   })

	var fadeInContours = gsap.utils.toArray('.fadeInContours');

	fadeInContours.forEach((section) => {

	 gsap.to(section, { alpha: 1, y: 0,
		scrollTrigger: {
			trigger: section,
			start: 'top 95%',
			scrub: true,
			end: 'top -25%',
		  toggleActions: "play none none reverse"
		  },
		  ease: "power3.easeOut"
		});

	})
 }


 if ( $('.fadeInLeft').length ) {

	gsap.set('.fadeInLeft', {  opacity: 0, x: -30   })

	var fadeInLefts = gsap.utils.toArray('.fadeInLeft');

	fadeInLefts.forEach((section) => {

	  gsap.to(section, { alpha: 1, x: 0,
		scrollTrigger: {
			trigger: section,
			start: 'top 90%',
			scrub: true,
			end: 'top 30%',
			//markers: true
		  },
		  ease: "power3.inOut"
		});

	})
 }


 if ( $('.fadeInRight').length ) {
	gsap.set('.fadeInRight', {  opacity: 0, x: 30   })

	var fadeInRights = gsap.utils.toArray('.fadeInRight');

	fadeInRights.forEach((section) => {

	  gsap.to(section, { alpha: 1, x: 0,
		scrollTrigger: {
			trigger: section,
			start: 'top 90%',
			scrub: true,
			end: 'top 30%',
			//markers: true
		  },
		  ease: "power3.inOut"
		});

	})
 }


 if ( $('.fadeInStaggered').length ) {
	gsap.defaults({ease: "power3"});
	gsap.set(".fadeInStaggered", {opacity: 0});

	ScrollTrigger.batch(".fadeInStaggered", {
	  //interval: 0.1, // time window (in seconds) for batching to occur. 
	  //batchMax: 3,   // maximum batch size (targets)
	  onEnter: batch => gsap.to(batch, {opacity: 1, stagger: {each: 0.25, grid: [1, 3]}, overwrite: true}),
	  onLeave: batch => gsap.set(batch, {opacity: 0, ease: "power3.inOut", overwrite: true}),
	  onEnterBack: batch => gsap.to(batch, {opacity: 1, stagger: 0.25, overwrite: true}),
	  onLeaveBack: batch => gsap.set(batch, {opacity: 0, ease: "power3.inOut", overwrite: true}),
	  start: 'top 80%'
	});
 }


// when ScrollTrigger does a refresh(), it maps all the positioning data which 
// factors in transforms, but in this example we're initially setting all the ".box"
// elements to a "y" of 100 solely for the animation in which would throw off the normal 
// positioning, so we use a "refreshInit" listener to reset the y temporarily. When we 
// return a gsap.set() in the listener, it'll automatically revert it after the refresh()!
ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".fadeInStaggered", {y: 0}));












/*
SHOULD ONLY WORK ON PHILOSOPHY PAGE

var pinner = document.getElementsByClassName("pinner");
if(typeof(pinner) != 'undefined' && pinner != null){
let innerContainer = document.getElementsByClassName("scrollHorizontally");
ScrollTrigger.create({
  trigger: ".pinner",
  markers: {startColor: "grey", endColor: "grey"},
  start: "top 30%", 
  //end: () => "+=" + innerContainer.outerWidth, 
  end: "bottom 30%",
  pinSpacing: false,
  pin: ".toBePinned",
  anticipatePin: 10,
  pinSpacing: true
});
}
    
*/
    

jQuery(document).ready(function($) {

/* if ( $('#anim-0').length ) {	
  const anim0 = lottie.loadAnimation({
    container: $('#anim-0').get(0),
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: "//cdn.shopify.com/s/files/1/0541/0914/3214/t/7/assets/json_1.js"
  }); 
	
	
	$(window).on('load', function() {
		anim0.play();
	});
}  */
  
  
  


  if ( $('#horizontalScrollContainer').length ) {

          /* philosophy page graphics: */

    let container = document.getElementById("horizontalScrollContainer");

    gsap.to(container, {
      x: () => -(container.scrollWidth - document.documentElement.clientWidth + 200) + "px",
      ease: "none",
      scrollTrigger: {
     // markers: true,
        //trigger: '#philosophyGraphics_beautyRitual',
        trigger: '#horizontalScrollContainer',
      pin: ".main-content",
        pinSpacing: true,
      pinType: "transform",
        invalidateOnRefresh: true,
        scrub: 1,
      start: "top 30%",
        end: "bottom 30%" //() => "+=" + container.offsetWidth
      }
    })

  }




	 /* The product buy box used to be pinned with ScrollTrigger (pinType: transform), which
	    re-positioned it on every scroll event and visibly jittered. It is now CSS position: sticky
	    (theme.css, .product-single / .productDetailDescription). The only script left is the offset:
	    a column shorter than the viewport sticks 80px from the top; a taller one gets a negative
	    offset so it scrolls with the page until its bottom is in view, then sticks there. */
	 (function () {
	   var col = document.querySelector('.product-single > .productDetailDescription');
	   if (!col) { return; }
	   var TOP = 80, BOTTOM_GAP = 24;
	   function updateStickyTop() {
	     var vh = window.innerHeight, h = col.offsetHeight;
	     var top = (h + TOP + BOTTOM_GAP > vh) ? (vh - h - BOTTOM_GAP) : TOP;
	     col.style.setProperty('--pdp-sticky-top', Math.round(top) + 'px');
	   }
	   updateStickyTop();
	   window.addEventListener('resize', updateStickyTop);
	   if (window.ResizeObserver) { new ResizeObserver(updateStickyTop).observe(col); }
	   window.addEventListener('load', updateStickyTop);
	 })();



  
  
  
 jQuery('a:not(.external):not(.inPage):not(.magnificPopup):not(.magnificVideo):not(.magnificImage):not([target="_blank"])').on('click', function(e) {
		
		if (jQuery(this).hasClass('external')) { return true; }
		e.preventDefault();
		if (jQuery(this).data('href')) { $href = jQuery(this).data('href'); } 
			else { $href=jQuery(this).attr('href'); }

		if ($href!='#') { 
			//jQuery('header.site-header:not(.sticky)').removeClass('before')
			jQuery('#loader').fadeIn();
			jQuery('.site-header__mobile-nav').removeClass('small');
			//$('html,body').animate({ scrollTop: 0 }, 200);
			jQuery('#animsition').delay(300).animate({ 'opacity':'0', 'margin-top':'0%'}, function() {
				window.location.href=$href;
			});
		} 
	})

  
  $('.site-footer__item:contains("{logo}")').html('<img id="footerIcon" src="https://cdn.shopify.com/s/files/1/0541/0914/3214/files/footerIcon.png?v=1614347290" alt="logo" />'); 

  	
	/* product detail page  tabs*/
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      })
    })
  
    
   
})


/*
jQuery(window).scroll(function ($) {
    if (jQuery(document).scrollTop() == 0) {
        jQuery('.site-header__mobile-nav').removeClass('small');
    } else {
        jQuery('.site-header__mobile-nav').addClass('small');
    }
})
*/


// Mobile PDP gallery: initialise Flickity as soon as the DOM is ready instead of on window load.
// Waiting for window load (all images + third-party scripts) delayed the first paint of the
// gallery by 15-20 s on throttled mobile and became the page's LCP. Images now carry
// width/height attributes, so cell heights are known before the images load.
jQuery(function() {
  var w = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  var group = jQuery('.product-single__media-group');
  if (w < 750 && group.length && !group.hasClass('flickity-enabled')) {
    group.flickity({
      cellSelector: '.product-single__media', pageDots: false,
      contain: false, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 60, y2: 40, x3: 20 }
    });
  }
});

jQuery(window).on('load resize', function() {
  if (jQuery('.announcement-bar').length) {
    var barHeight = jQuery('.announcement-bar').height();
    jQuery('header.site-header').animate({'top': barHeight}); 
  }

  jQuery('body:not(.template-index) #animsition').animate({ 'margin-top' : jQuery('.site-header').height() * 1 });
  
  ScrollTrigger.refresh();
  
  var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  if (width < 750)
    jQuery('.product-single__media-group').flickity({
      cellSelector: '.product-single__media', pageDots: false,
      contain: false,arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 60, y2: 40,
        x3: 20
      }
    });
  else
    jQuery('.product-single__media-group').flickity('destroy');
  
})


// Page reveal: #animsition starts at opacity 0 (theme.css) and used to fade in on window load,
// i.e. after every image and third-party script. On throttled mobile that left the page blank
// for 15-20 s and made the window load event the LCP. Reveal at DOM ready instead; the header
// offset is applied first so the content does not jump when the load handler runs.
jQuery(function() {
  var revealed = false;
  var reveal = function() {
    if (revealed) { return; }
    revealed = true;
    if (typeof applyHeaderOffset === 'function') { applyHeaderOffset(); }
    jQuery('#loader').fadeOut();
    jQuery('#animsition').animate({'opacity': '1'}, function() {
      if (window.location.hash && jQuery(window.location.hash).length) {
        jQuery("html, body").animate({ scrollTop: jQuery(window.location.hash).offset().top - 20 });
      }
    });
  };
  // theme.css loads asynchronously; wait for it so the header offset is measured on the styled header
  // (otherwise the page is revealed and then jumps). Fall back after 1.5 s so a slow stylesheet never blanks the page.
  var css = document.querySelector('link[href*="theme.css"]');
  if (window.themeStylesheetLoaded || !css) {
    reveal();
  } else {
    css.addEventListener('load', reveal, { once: true });
    setTimeout(reveal, 1500);
  }
});

jQuery(window).on('load', function() {

  /* hack mega menu content: SHOP dropdown images + taglines, keyed by link so the menu can be reordered in the admin */
    var megaMenuContent = {
      '/collections': {
        img: 'https://cdn.shopify.com/s/files/1/0541/0914/3214/files/Editrix-Wellness-Lineup_opt.jpg?v=1694617438',
        text: 'A microbiome-first skincare ritual designed to support the barrier, restore visible resilience, and help overtreated skin function at its best.'
      },
      '/products/at-home-microneedle-treatment': {
        img: 'https://cdn.shopify.com/s/files/1/0541/0914/3214/files/editrix-microneedle_crop_41e34023-6739-42e4-b487-a96639d373ef.jpg?v=1694550511',
        text: 'Innovative at-home microneedle therapy for an instant luminosity boost.'
      },
      '/products/the-scalp-edit-n-001': {
        img: 'https://cdn.shopify.com/s/files/1/0541/0914/3214/files/EDX-SCEDIT-001_1opt.jpg?v=1789839356',
        text: 'A Dual Protocol for the Follicle Microbiome and Aging Scalp<br>Daily Microbiome Serum + Weekly Senolytic Microneedles'
      }
    };
    jQuery.each(megaMenuContent, function(href, item) {
      var $item = jQuery('.site-nav--has-dropdown:first-child a.site-nav__child-link[href$="' + href + '"] .childlink-img');
      $item.find('img').attr('src', item.img);
      jQuery('<div class="mega-menu-description">' + item.text + '</div>').insertAfter($item.find('.site-nav__label'));
    });
  /* end hack mega menu content */
})

/*
jQuery(window).on('load resize', function($) {
  
  jQuery('body:not(.template-index) #animsition').css({ 'margin-top' : jQuery('.site-header').height() * 1 });
  ScrollTrigger.refresh();
  
})


jQuery(window).on('load', function() {

	jQuery('#loader').fadeOut();
	jQuery('#animsition').animate({'opacity': '1'}, function() {
		if(window.location.hash) { 
			jQuery("html, body").animate({ scrollTop: jQuery(window.location.hash).offset().top - 20 });
			}
		}
	)
})
*/